import { useEffect, useState } from "react";
import { useParams } from "react-router-dom"
import { OndcService } from "../../../../../app/core/ondc.service";
import { Breadcrumb } from "../../../../../components/breadcum";
import { IMAGE_PATH } from "../../../../../config";
import { FormatIndianDate } from "../../../../../app/utility/formatIndianDate";

export const ONDCOrdersView = () => {
    const params = useParams();
    const [orderDetails, setOrderDetails] = useState<any>();
    const [loading, setLoading] = useState<boolean>(false);
    const [productIds, setProductIds] = useState<any>([]);
    useEffect(() => {
        getOrderDetails();
    }, []);

    const getOrderDetails = async () => {
        setLoading(true);
        let payload = {
            id: params.id
        }
        try {
            const res = await OndcService.getOndcOrders(payload);
            setOrderDetails(res?.results[0]);
            setLoading(false);
        }
        catch (error) {
            setLoading(false);
        }
    }

    const breadcrumbInfo = [
        {
            label: "ONDC Orders",
            value: "ONDC Orders",
            routerLink: `/dashboard/ondc-orders`,
            isActive: false,
        },
        {
            label: `Info`,
            value: `Info`,
            routerLink: ``,
            isActive: true,
        },
    ];

    const handleSelectProduct = (id: string) => {
        if (productIds.includes(id)) {
            setProductIds(productIds.filter((item: any) => item !== id));
        } else {
            // setProductIds([...productIds, id]);
            setProductIds([id]);
        }
    };

    const handleCancel = async () => { }
    return (
        <div className="container-fluid content-bg-color">
            <Breadcrumb breadCrumbList={breadcrumbInfo}></Breadcrumb>
            <h4 className="primary-color fw-bold mb-0">Order Details</h4>
            {loading ? (
                <div className="text-center p-5">
                    <div className="spinner-border" role="status">
                        <span className="sr-only"></span>
                    </div>
                </div>
            ) : (
                <div className="card mt-2">
                    <div className="card-body">
                        <div className="text-end fw-bold">Order Created Date : {FormatIndianDate(orderDetails?.created_dt, "")}</div>
                        <div className="my-2">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-4 mb-3 lh-1-5">
                                            <div className="mb-0 fw-bold">bap Id</div>
                                            <>{orderDetails?.select?.context?.bap_id}</>
                                        </div>
                                        <div className="col-md-4 mb-3 lh-1-5">
                                            <div className="mb-0 fw-bold">Order Id</div>
                                            <>{orderDetails?.order_id}</>
                                        </div>
                                        <div className="col-md-4 mb-3 lh-1-5">
                                            <div className="mb-0 fw-bold">Txn No</div>
                                            <>{orderDetails?.select?.context?.transaction_id}</>
                                        </div>
                                        <div className="col-md-4 mb-3 lh-1-5">
                                            <div className="mb-0 fw-bold">Seller Name</div>
                                            <>{orderDetails?.select?.message?.order?.provider?.id}</>
                                        </div>
                                        <div className="col-md-4 mb-3 lh-1-5">
                                            <div className="mb-0 fw-bold">Buyer Name</div>
                                            <>{orderDetails?.on_confirm?.message?.order?.billing?.name}</>
                                        </div>
                                        <div className="col-md-4 mb-3 lh-1-5">
                                            <div className="mb-0 fw-bold">Amount</div>
                                            {orderDetails?.on_confirm && <>₹ {orderDetails?.on_confirm?.message?.order?.quote?.price?.value} ({orderDetails?.on_confirm?.message?.order?.payment?.status})</>}
                                        </div>
                                        <div className="col-md-4 mb-3 lh-1-5">
                                            <div className="mb-0 fw-bold">City</div>
                                            <>{orderDetails?.select?.context?.city}</>
                                        </div>
                                        <div className="col-md-8 mb-3 lh-1-5">
                                            <div className="mb-0 fw-bold">Address</div>
                                            {orderDetails?.on_confirm && <div>
                                                <div>{orderDetails?.on_confirm?.message?.order?.billing?.address?.name},<div />
                                                    <div>{orderDetails?.on_confirm?.message?.order?.billing?.address?.building},{orderDetails?.on_confirm?.message?.order?.billing?.address?.locality},{orderDetails?.on_confirm?.message?.order?.billing?.address?.city},{orderDetails?.on_confirm?.message?.order?.billing?.address?.state},{orderDetails?.on_confirm?.message?.order?.billing?.address?.country},{orderDetails?.on_confirm?.message?.order?.billing?.address?.area_code},</div>
                                                    <div>{orderDetails?.on_confirm?.message?.order?.billing?.phone}.</div>
                                                </div>
                                            </div>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card mt-3">
                            <div className="card-body">
                                <h5 className="fw-bold mb-1">Product Details :</h5>
                                {orderDetails?.selected_products?.length > 0 && orderDetails?.selected_products.map((item: any, index: number) => (
                                    <div key={index} className="card mb-2 rounded border-secondary">
                                        <div className="card-body">
                                            <div className="form-check"><input className="form-check-input border border-secondary p-2 cursor-pointer" type="checkbox" value="" id="flexCheckDefault" checked={productIds.includes(item.order_id)} onClick={() => handleSelectProduct(item.order_id)} /></div>
                                            <div className="row align-items-center fs-14">
                                                <div className="col-md-2">Batch : {item?.batch_pricing?.batch_number}</div>
                                                <div className="col-md-4 lh-2">{item.name}</div>
                                                <div className="col-md-4">quantity: {item.quantity}</div>
                                                <div className="col-md-2">Total: ₹{item?.batch_pricing?.price}</div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                <div className="text-center mt-4"><button className={`btn ${productIds.length === 0 ? "disabled-btn border-secondary" : "btn-danger"}`} onClick={() => handleCancel()}>Cancel</button></div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}